import { usePortal } from '../../hooks/useNavConfig';
import { withErrorBoundary } from '../ErrorBoundary';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { AccountsAndBillingLink } from './AccountsExtrasLinks/AccountsAndBillingLink';
import { AcademyLink } from './AccountsExtrasLinks/AcademyLink';
import { PricingAndFeaturesLink } from './AccountsExtrasLinks/PricingAndFeaturesLink';
import { ProductUpdatesLink } from './AccountsExtrasLinks/ProductUpdatesLink';
import { ProjectsLink } from './AccountsExtrasLinks/ProjectsLink';
import { TrainingAndServicesLink } from './AccountsExtrasLinks/TrainingAndServicesLink';
import HubSpotCreditsLink from './AccountsExtrasLinks/HubspotCreditsLink/HubSpotCreditsLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const _AccountExtras = ({
  isDevPortal,
  hasProjectAccess
}) => {
  const {
    portalId
  } = usePortal();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PricingAndFeaturesLink, {
      portalId: portalId,
      isDevPortal: isDevPortal
    }), /*#__PURE__*/_jsx(AccountsAndBillingLink, {
      isDevPortal: isDevPortal,
      portalId: portalId
    }), /*#__PURE__*/_jsx(HubSpotCreditsLink, {
      portalId: portalId
    }), /*#__PURE__*/_jsx(ProductUpdatesLink, {
      portalId: portalId,
      isDevPortal: isDevPortal
    }), /*#__PURE__*/_jsx(AcademyLink, {
      portalId: portalId,
      isDevPortal: isDevPortal
    }), /*#__PURE__*/_jsx(TrainingAndServicesLink, {}), /*#__PURE__*/_jsx(ProjectsLink, {
      portalId: portalId,
      hasProjectAccess: hasProjectAccess
    })]
  });
};
export const AccountExtras = withErrorBoundary(memoWithDisplayName('AccountExtras', _AccountExtras), {
  boundaryName: 'AccountExtras'
});